import { u, styled } from '../../shared/theming-sc'

import ButtonBase from '../button-base'

const StyledPrimaryButton = styled(ButtonBase)`
  background-color: ${p => (u.getColor(p.disabled ? 'greyLight' : 'accent1'))};
  pointer-events: ${p => (p.disabled ? 'none' : 'auto')};
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};

  font-size: ${u.getFontSize('md')};
  font-family: ${u.getFontFamily('knowledge', 'bold')};
  padding: ${u.getSpacing('small')}px ${u.getSpacing('large')}px;
  color: white;
  border-radius: 5px;
  transition: background 0.15s linear;

  &:hover {
    background-color: ${u.getColor('accent1Dark')};
  }
`

export { StyledPrimaryButton }
